import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonText, IonTitle, IonToolbar } from '@ionic/react';
import { alertCircle, arrowBack, chatboxEllipses, checkmarkCircleOutline, radioButtonOff } from 'ionicons/icons';
import { getStateStringAsMoment } from '../../../common/util';
import { ITechComment } from '../../../models/dms/technicianComments.model';
import { IonModalWrapper } from './TechnicianCommentModal.styles';

export interface IComponentProps {
  techComment: ITechComment;
  showModal: boolean;
  handleDismiss?: () => void;
}

const TechnicianCommentModal: React.FC<IComponentProps> = function ({ techComment, showModal, handleDismiss }) {
  return (
    <IonModalWrapper
      className="stacked-modal"
      isOpen={showModal}
      onDidDismiss={() => {
        if (showModal) {
          handleDismiss && handleDismiss();
        }
      }}>
      <IonHeader color="lightest">
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonButton fill="solid" onClick={() => handleDismiss && handleDismiss()}>
              <IonIcon icon={arrowBack} />
            </IonButton>
          </IonButtons>
          <IonTitle>Technician Comment</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent color="lightest" className="ion-padding">
        <IonList>
          <IonItem lines="none">
            {!techComment.actioned && <IonIcon slot="end" icon={radioButtonOff} color="medium" />}
            {techComment.actioned && <IonIcon slot="end" icon={checkmarkCircleOutline} color="success" />}

            <IonLabel>
              <IonText color="medium">
                <p className="date-label">{getStateStringAsMoment(techComment.createdDateTime).format('MMM DD, YYYY HH:mm:ss')}</p>
              </IonText>
              <IonText className="ion-text-capitalize">
                <strong>{techComment.technicianDisplayName}</strong>
              </IonText>
            </IonLabel>

            {!techComment.isAlert && <IonIcon icon={chatboxEllipses} slot="start" color="medium" size="large" />}
            {techComment.isAlert && 'TechAlert' && <IonIcon icon={alertCircle} slot="start" color="medium" size="large" />}
          </IonItem>
          <IonItem lines="none">
            <IonLabel>
              <IonText className="comment">{techComment.comment}</IonText>
            </IonLabel>
          </IonItem>
        </IonList>
      </IonContent>
    </IonModalWrapper>
  );
};

export default TechnicianCommentModal;
